<div
  *ngIf="!saveSuccess"
  class="email-capture-tray mat-elevation-z10"
  [ngClass]="breakpoints.isMobile ? 'mobile' : ''"
  data-cy="email-collection-tray.tray"
  @slideUpDown
>
  <img
    src="../../../assets/images/rounded-polygon.svg"
    class="shape"
    aria-hidden="true"
    alt=""
    [ngClass]="breakpoints.isMobile ? 'xs-shape' : ''"
  />
  <platform-page-container [fullscreen]="false" [contentSpacing]="true">
    <button
      class="platform-button button-dark button-small close-button"
      [ngClass]="breakpoints.isMobile ? 'xs-close-button' : ''"
      mat-icon-button
      (click)="closeTray.emit(true)"
      [attr.aria-label]="'app_global_cancel_email_tray' | translate"
      data-cy="email-collection-tray-close-button"
    >
      <mat-icon svgIcon="dls-times-plain-light"> </mat-icon>
    </button>
    <div
      class="compare-tray-header flex"
      [ngClass]="breakpoints.isMobile ? 'flex-col' : 'flex-row'"
    >
      <div class="heading-container">
        <h1 class="heading">{{ 'email_capture_heading' | translate }}</h1>
        <span class="subhead">{{ 'email_capture_subhead' | translate }}</span>
      </div>

      <div class="email-capture-container pl-4">
        <div *ngIf="saveSuccess === false" class="error-message">
          {{ 'email_capture_save_error_text' | translate }}
        </div>
        <mat-form-field appUnfocus class="email-form mb-4 w-full">
          <mat-label
            class="email-label"
            [innerHTML]="getErrorMessage() | translate"
          ></mat-label>
          <input
            class="no-halo"
            data-cy="email-collection-tray.input"
            matInput
            [formControl]="email"
            required
          />
        </mat-form-field>
        <div
          class="legal-copy"
          [innerHTML]="'email_capture_legal_copy' | translate"
        ></div>
        <div
          class="terms"
          [innerHTML]="'email_capture_agree_text' | translate"
        ></div>
        <div class="submit-container">
          <button
            class="platform-button mat-flat-button mat-accent submit-button"
            [ngClass]="breakpoints.isMobile ? 'xs-submit-button' : ''"
            appGtm
            data-cy="email-collection-tray.submit-button"
            [gtmOnClick]="true"
            [gtmData]="{ event: 'gtm.email_capture.submit' }"
            [disabled]="hasError()"
            (click)="submit()"
          >
            {{ 'app_global_submit' | translate }}
          </button>
        </div>
      </div>
    </div>
  </platform-page-container>
</div>

<div
  *ngIf="saveSuccess"
  class="email-capture-tray-success mat-elevation-z10"
  data-cy="email-collection-tray.success-tray"
  [ngClass]="breakpoints.isMobile ? 'mobile' : ''"
  @slideUpDown
>
  <button
    class="platform-button button-dark button-small close-button"
    mat-icon-button
    (click)="closeTray.emit(true)"
    [attr.aria-label]="'app_global_close' | translate"
  >
    <mat-icon svgIcon="dls-times-plain-light"> </mat-icon>
  </button>
  <div
    class="success-message flex flex-col lg:flex-row"
    data-cy="email-collection-tray.success-message"
  >
    <img
      src="../../../assets/images/success_illo.svg"
      class="order-2 lg:order-first"
      aria-hidden="true"
      alt=""
    />
    <div class="flex lg:flex-col self-start place-content-evenly">
      <div class="success-header">
        <h2 class="text-bold">{{ 'email_capture_success' | translate }}</h2>
      </div>
      <div
        class="success-text"
        [innerHTML]="'email_capture_success_text' | translate"
      ></div>
    </div>
  </div>
</div>
